import { render, staticRenderFns } from "./fieldMultipleInput.vue?vue&type=template&id=6a072070"
import script from "./fieldMultipleInput.vue?vue&type=script&lang=js"
export * from "./fieldMultipleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports